import { http, HttpResponse } from "msw"
import type { ApiFinancialDataBiosimilarsSummary } from "../../../performance/biosimilars"
import { biosimilarsSummaryMock } from "./biosimilarsSummary.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataBiosimilarsSummaryHandlers = [
  // ADH
  http.get(
    `${API_DOMAIN}/api/financial-data/adherent/performance/biosimilars/summary`,
    () =>
      HttpResponse.json<ApiFinancialDataBiosimilarsSummary>(
        biosimilarsSummaryMock(),
      ),
  ),
  // ADMIN
  http.get(
    `${API_DOMAIN}/api/financial-data/pharmacies/:pharmacyId/performance/biosimilars/summary`,
    () =>
      HttpResponse.json<ApiFinancialDataBiosimilarsSummary>(
        biosimilarsSummaryMock(),
      ),
  ),
  // ADVISOR
  http.get(
    `${API_DOMAIN}/api/financial-data/advisor/pharmacies/:pharmacyId/performance/biosimilars/summary`,
    () =>
      HttpResponse.json<ApiFinancialDataBiosimilarsSummary>(
        biosimilarsSummaryMock(),
      ),
  ),
  // PRESIDENT
  http.get(
    `${API_DOMAIN}/api/financial-data/president/pharmacies/:pharmacyId/performance/biosimilars/summary`,
    () =>
      HttpResponse.json<ApiFinancialDataBiosimilarsSummary>(
        biosimilarsSummaryMock(),
      ),
  ),
]
